import {brasRequest} from '../util/net';
import {lng} from '../ulanguages/language';
import he from 'he';
import { routes } from './../store/ApiRoutes';
import { isServer } from '../util/windowUtil';
import WYSIWYGButton from './WYSIWYGButton';
import { isSet } from './../util/typeu';


export function generateImageManagerButtons(imgId){
    let upperDivId='wrimgup-'+imgId;
    let removeBtn = '<div class="wsyWriterimageWrapperBtn wsyImgRemoveBtn" onclick="window.wsyUtils.removeElementByName(\''+upperDivId+'\')"> <i class="fas fa-trash-alt"></i> </div>';
    let spoilerBtn = '<div class="wsyWriterimageWrapperBtn wsyImgSpoilerBtn" onclick="window.wsyUtils.addRemoveSpoiler(\''+upperDivId+'\')"> <i class="fas fa-eye-slash"></i> </div>';
    let btns = removeBtn+spoilerBtn;
    return btns;
}

function replaceTextInRange(inputString, start, end, replacementText) {
    if (start < 0 || end > inputString.length || start > end) {
        console.error("Invalid start or end positions.");
        return inputString;
    }

    const part1 = inputString.substring(0, start);
    const part2 = inputString.substring(end);

    return part1 + replacementText + part2;
}

export function prepareStartContent(text){
    //add image wrappers
    let pos=0;
    let firstText = text.replaceAll("data-xname","name");
    firstText = firstText.replaceAll("class=\"wsyWriterimageWrapper\"","class=\"wsyWriterimageWrapper\" contenteditable=\"false\"");

    
    let editText = firstText;
    let finalText = firstText;
    let basePos=0;
    pos = editText.indexOf('<div name="wrimgup-');
    while(pos!==-1)
    {
        editText = editText.substr(pos+'<div name="wrimgup-'.length);
        basePos+=pos+'<div name="wrimgup-'.length; //add to start
        //====
        pos = editText.indexOf('"');
        let imgNumber = editText.substring(0,pos);
        //=====
        pos = editText.indexOf('>');
        editText = editText.substr(pos+'>'.length);
        basePos+=pos+'>'.length; //add to start
        let lastPos=editText.indexOf('<img name="wrimg-')+basePos;

        let btns = generateImageManagerButtons(imgNumber);
        finalText = replaceTextInRange(finalText,lastPos,lastPos,btns);

        editText=finalText.substr(lastPos+btns.length);
        basePos=lastPos+btns.length;
        pos = editText.indexOf('<div name="wrimgup-');
    }
    return finalText;
}
export function prepareContentToSend(text){
    //add image wrappers
    let pos=0;
    
    let editText = text;
    let finalText = text;
    let basePos=0;
    pos = editText.indexOf('<div name="wrimgup-');
    while(pos!==-1)
    {
        editText = editText.substr(pos+'<div name="wrimgup-'.length);
        basePos+=pos+'<div name="wrimgup-'.length; //add to start
        //====
        pos = editText.indexOf('"');
        let imgNumber = editText.substring(0,pos);
        //=====
        pos = editText.indexOf('>');
        editText = editText.substr(pos+'>'.length);
        basePos+=pos+'>'.length; //add to start
        pos = editText.indexOf('<div');
        editText = editText.substr(pos);
        basePos+=pos;
        pos = editText.indexOf('>');
        editText = editText.substr(pos+'>'.length);
        basePos+=pos+'>'.length; //add to start
        pos = editText.indexOf('<div');
        editText = editText.substr(pos);
        basePos+=pos;

        let lastPos=editText.indexOf('<img name="wrimg-')+basePos;
        finalText = replaceTextInRange(finalText,basePos,lastPos,"");
        
        editText=finalText.substr(basePos);
        pos = editText.indexOf('<div name="wrimgup-');
    }
    finalText = finalText.replaceAll("name=\"","data-xname=\"");
    return finalText;
}
let test = '<div class="writeBox " placeholder="Escreva sua folha de rosto!" id="258455037" contenteditable="true">Teste 12365789<br><div name="wrimgup-716528749"><span class="spoiler"><div class="wsyWriterimageWrapper" contenteditable="false"><div class="wsyWriterimageWrapperBtn wsyImgRemoveBtn" onclick="window.wsyUtils.removeElementByName(\'wrimgup-716528749\')"> <i class="fas fa-trash-alt"></i> </div><div class="wsyWriterimageWrapperBtn wsyImgSpoilerBtn" onclick="window.wsyUtils.addRemoveSpoiler(\'wrimgup-716528749\')"> <i class="fas fa-eye-slash"></i> </div><img name="wrimg-716528749" src="https://i.imgur.com/ieC10Mq.png"></div> <div name="wrimgup-716528749"><span class="spoiler"><div class="wsyWriterimageWrapper" contenteditable="false"><div class="wsyWriterimageWrapperBtn wsyImgRemoveBtn" onclick="window.wsyUtils.removeElementByName(\'wrimgup-716528749\')"> <i class="fas fa-trash-alt"></i> </div><div class="wsyWriterimageWrapperBtn wsyImgSpoilerBtn" onclick="window.wsyUtils.addRemoveSpoiler(\'wrimgup-716528749\')"> <i class="fas fa-eye-slash"></i> </div><img name="wrimg-716528749" src="https://i.imgur.com/ieC10Mq.png"></div></span></div><br><div><br></div><div><br><div><br></div><br><div><br></div><div><br></div></div></div>';

let toSend = prepareContentToSend(test);
let result = prepareStartContent(toSend);
//console.log("TEST:",test,"RESULT:",result,"TOSEND::",toSend);

function purifyEntrada(htmlarg)
{
    let html = htmlarg.replaceAll('<',String.fromCharCode(14)).replaceAll('>',String.fromCharCode(16));
    html = he.decode(html);
    html = html.replaceAll('<',String.fromCharCode(15));
    html = html.replaceAll('>',String.fromCharCode(17));

    html = html.replaceAll(String.fromCharCode(14),'<');
    html = html.replaceAll(String.fromCharCode(16),'>');
    return html;
}
function depurifyEntrada(htmlarg)
{
    let html = htmlarg.replaceAll(String.fromCharCode(15),'&lt;').replaceAll(String.fromCharCode(17),'&gt;');
    return html;
}


if (!isServer())
{
    window.wsyUtils = {};
    window.wsyUtils.removeElementByName=function(elementId)
    {
       let element =  document.getElementsByName(elementId)[0];
       if (isSet(element))
        element.outerHTML = "";
    }
    window.wsyUtils.addRemoveSpoiler=function(elementId)
    {
        let element =  document.getElementsByName(elementId)[0];
        if (isSet(element))
        {
            let text = element.innerHTML;
            //console.log(text);
           // console.log("ADD REMOVE SPOILER");
            if (text.indexOf('class="spoiler"')!==-1)
            {
                //console.log("REMOVE");
                //remove
                let tagclass = '.spoiler';
                let editorNode = element;
                let offending = editorNode.querySelectorAll(tagclass)
                if(offending)
                {
                    offending.forEach(element => {
                        //console.log("offeding:",element.textContent.length);
                        element.classList.remove(tagclass.substr(1));
                        //console.log('removing', element);
                    });
                }
            }
            else
            {//add
                //console.log("ADD");
                element.innerHTML = '<span class="spoiler">'+element.innerHTML+'</span>';
            }
        }
    }
}

export var htmlToBBCode = function(html) {

    html = html.replace(/<pre(.*?)>(.*?)<\/pre>/gmi, "[code]$2[/code]");
  
      html = html.replace(/<h[1-7](.*?)>(.*?)<\/h[1-7]>/, "\n[h]$2[/h]\n");

      html = html.replace(/<span class="spoiler"(.*?)>(.*?)<\/span>/, "[spoiler]$2[/spoiler]");
  
      //paragraph handling:
      //- if a paragraph opens on the same line as another one closes, insert an extra blank line
      //- opening tag becomes two line breaks
      //- closing tags are just removed
      // html += html.replace(/<\/p><p/<\/p>\n<p/gi;
      // html += html.replace(/<p[^>]*>/\n\n/gi;
      // html += html.replace(/<\/p>//gi;
  
      html = html.replace(/<br(.*?)>/gi, "\n");
      html = html.replace(/<textarea(.*?)>(.*?)<\/textarea>/gmi, "[code]$2[/code]");
      html = html.replace(/<b>/gi, "[b]");
      html = html.replace(/<i>/gi, "[i]");
      html = html.replace(/<u>/gi, "[u]");
      html = html.replace(/<\/b>/gi, "[/b]");
      html = html.replace(/<\/i>/gi, "[/i]");
      html = html.replace(/<\/u>/gi, "[/u]");
      html = html.replace(/<em>/gi, "[b]");
      html = html.replace(/<\/em>/gi, "[/b]");
      html = html.replace(/<strong>/gi, "[b]");
      html = html.replace(/<\/strong>/gi, "[/b]");
      html = html.replace(/<cite>/gi, "[i]");
      html = html.replace(/<\/cite>/gi, "[/i]");
      html = html.replace(/<font color="(.*?)">(.*?)<\/font>/gmi, "[color=$1]$2[/color]");
      html = html.replace(/<font color=(.*?)>(.*?)<\/font>/gmi, "[color=$1]$2[/color]");
      html = html.replace(/<link(.*?)>/gi, "");
      html = html.replace(/<li(.*?)>(.*?)<\/li>/gi, "[*]$2");
      html = html.replace(/<ul(.*?)>/gi, "[list]");
      html = html.replace(/<\/ul>/gi, "[/list]");
      html = html.replace(/<div>/gi, "\n");
      html = html.replace(/<\/div>/gi, "\n");


      html = html.replace(/<table(.*?)>/gi, "[tb]");
      html = html.replace(/<\/table>/gi, "[/tb]");
      html = html.replace(/<td(.*?)>/gi, "[td]");
      html = html.replace(/<\/td>/gi, "[/td]");
      html = html.replace(/<tr(.*?)>/gi, "[tr]");
      html = html.replace(/<\/tr>/gi, "[/tr]");
      //html = html.replace(/<tr(.*?)>/gi, "\n");
  
      html = html.replace(/<img(.*?)src="(.*?)"(.*?)>/gi, "[img $1]$2[/img]");
      html = html.replace(/<a(.*?)href="(.*?)"(.*?)>(.*?)<\/a>/gi, "[url=$2]$4[/url]");
  
      html = html.replace(/<head>(.*?)<\/head>/gmi, "");
      html = html.replace(/<object>(.*?)<\/object>/gmi, "");
      html = html.replace(/<script(.*?)>(.*?)<\/script>/gmi, "");
      html = html.replace(/<style(.*?)>(.*?)<\/style>/gmi, "");
      html = html.replace(/<title>(.*?)<\/title>/gmi, "");
      html = html.replace(/<!--(.*?)-->/gmi, "\n");
  
      html = html.replace(/\/\//gi, "/");
      html = html.replace(/http:\//gi, "http://");
      html = html.replace(/https:\//gi, "https://");
  
      html = html.replace(/<(?:[^>'"]*|(['"]).*?\1)*>/gmi, "");
      html = html.replace(/\r\r/gi, ""); 
      html = html.replace(/\[img]\//gi, "[img]");
      html = html.replace(/\[url=\//gi, "[url=");
  
      html = html.replace(/(\S)\n/gi, "$1 ");
  
      return html;
  }


  
  //use if the other code does not work
function isChildOf(node, parentId) {
    while (node !== null) {
        if (node.id === parentId) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
};

export function getCurrentCursorPosition(parentId) {
    var selection = window.getSelection(),
        charCount = -1,
        node;

    if (selection.focusNode) {
        if (isChildOf(selection.focusNode, parentId)) {
            node = selection.focusNode; 
            charCount = selection.focusOffset;

            while (node) {
                if (node.id === parentId) {
                    break;
                }

                if (node.previousSibling) {
                    node = node.previousSibling;
                    charCount += node.textContent.length;
                } else {
                     node = node.parentNode;
                     if (node === null) {
                         break
                     }
                }
           }
      }
   }

    return charCount;
};
export function getCurrentCursorSelectionStart(parentId) {
    var selection = window.getSelection(),
        charCount = -1,
        node;

    if (selection.anchorNode) {
        if (isChildOf(selection.anchorNode, parentId)) {
            node = selection.anchorNode; 
            charCount = selection.anchorOffset;

            while (node) {
                if (node.id === parentId) {
                    break;
                }

                if (node.previousSibling) {
                    node = node.previousSibling;
                    charCount += node.textContent.length;
                } else {
                     node = node.parentNode;
                     if (node === null) {
                         break
                     }
                }
           }
      }
   }

    return charCount;
};


function createRange(node, chars) {
    let range = document.createRange()
    range.selectNode(node);
    range.setStart(node, 0);

if (chars.count === 0) {
    range.setEnd(node, chars.count);
} else if (node && chars.count >0) {
    if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.length < chars.count) {
            chars.count -= node.textContent.length;
        } else {
            range.setEnd(node, chars.count);
            chars.count = 0;
        }
    } else {
       for (var lp = 0; lp < node.childNodes.length; lp++) {
            range = createRange(node.childNodes[lp], chars, range);

            if (chars.count === 0) {
                break;
            }
        }
    }
} 

return range;
};

var customWriterIds=0;

function generateRandomId() {
    const randomId = Math.floor(Math.random() * 1000000000); // Generates a random number from 0 to 999999999
    return randomId.toString(); // Convert the number to a string
}

export function genRandId(prefix='')
{
    customWriterIds += 1;
    return prefix + generateRandomId();
}

export function setCurrentCursorPosition(chars,editorId) {
if (chars >= 0) {
    var selection = window.getSelection();

    let range = createRange(document.getElementById(editorId).parentNode, { count: chars });

    if (range) {
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
};

function getOpenandOrphanCloseTags(openingTags,openingTagsPos,closingTags,closingTagsPos)
{
    //console.log('open tags:',openingTags);
    //console.log('closing tags:',closingTags);
    
    let openTags = [];
    let closeTags = [];
    for(let i=closingTags.length-1; i>=0;i--)
    {
        for(let k=openingTags.length-1; k>=0;k--)
        {
            if (openingTags[k].indexOf(closingTags[i])!==-1 && closingTags[i]!=='' && openingTags[k]!=='' && closingTagsPos[i]>openingTagsPos[k])
            {
                openingTags[k] = '';
                closingTags[i] = '';
                break;
            }
        }
    }
    for(let k=openingTags.length-1; k>=0;k--)
    {
        if (openingTags[k]!=='')
            openTags[openTags.length] = openingTags[k];
    }
    for(let k=closingTags.length-1; k>=0;k--)
    {
        if (closingTags[k]!=='')
            closeTags[closeTags.length] = closingTags[k];
    }
    return {open:openTags,close:closeTags};
}

export function realCaretAndSelectionPos(htmlarg, fakePos,anchorFakePos)
{
    let html = purifyEntrada(htmlarg);
    //console.log("res:", html);
    let pos=0;
    let tagPos = 0;

    let closingTags = [];
    let openingTags = [];
    let openingTagsPos = [];
    let closingTagsPos = [];
    let tag='';

    let dif = 0;
    let open=false;
    let dif2=0;
    let selectionString = window.getSelection().toString();
    let realPos = fakePos;
    let selectionRealStart= anchorFakePos;//realPos - selectionString.length;
    if (anchorFakePos>fakePos && selectionString.length>0)
    {
            selectionRealStart = fakePos;
            realPos = anchorFakePos;
    }
    while(pos<realPos)
    {
        if (html.charAt(pos)==='<')
            open=true;
        if (open)
        {
            dif+=1;
            dif2+=1;
            tagPos+=1;
        }
        pos+=1;
        if (pos===selectionRealStart)
        {
            selectionRealStart+=dif2;
            dif2=0;
        }
        if (pos===realPos)
        {
            realPos+=dif;
            dif = 0;
        }
        if (pos>1 && html.charAt(pos-1)==='>')
        {
            open = false;         
            let tagStart = pos-tagPos;
            open = false;
            tag = html.substring(tagStart,pos);
            tagPos=0;
            //console.log(tag);
            if (tag.indexOf('</')!==-1)
            {
                closingTags[closingTags.length] = tag.replace('/','').replace('>','');
                closingTagsPos[closingTagsPos.length] = tagStart;
            }
            else
            {
                openingTags[openingTags.length] = tag;  
                openingTagsPos[openingTagsPos.length] = tagStart;  
            }            
        }
    }
    let openAndCloseTags = getOpenandOrphanCloseTags(openingTags,openingTagsPos,closingTags,closingTagsPos);
    return {selectionRealStart,realPos,open:openAndCloseTags.open};
}

export function removeEmptyKnownTags(tags,editorNode)
{
    tags.forEach(tagclass => {
        let offending = editorNode.querySelectorAll(tagclass)
        if(offending)
            offending.forEach(element => {
                //console.log("offeding:",element.textContent.length);
            if (((element.innerHTML.length===0 || element.textContent.length===0) && element.innerHTML.indexOf('<img')===-1))
            {
                //console.log("ofendingClasses:",element.classList);
                element.classList.remove(tagclass.substr(1));
                //element.parentNode.removeChild(element);
                //console.log('removing', element);
            }
        });
    });
    let unaceptable = editorNode.querySelectorAll("span");
    if(unaceptable)
    {
        unaceptable.forEach(element => {
            element.removeAttribute("style");
        });
    }
}

//#### NOT BEING USED
export function htmlOpenTags(htmlarg, realPosarg)
{
    let html = purifyEntrada(htmlarg);
    let realPos = realPosarg;
    let pos=0;
    let open=false;
    let tag='';
    let tagPos=0;
    let closingTags = [];
    let openingTags = [];

    let openingTagsPos = [];
    let closingTagsPos = [];
    while(pos<realPos)
    {
        if (html.charAt(pos)==='<')
            open=true;
        if (open)
        {
            tagPos+=1;
        }
        pos+=1;
        if (pos>1 && html.charAt(pos-1)==='>')
        {
            let tagStart = pos-tagPos;
            open = false;
            tag = html.substring(tagStart,pos);
            tagPos=0;
            //console.log(tag);
            if (tag.indexOf('</')!==-1)
            {
                closingTags[closingTags.length] = tag.replace('/','').replace('>','');
                closingTagsPos[closingTagsPos.length] = tagStart;
            }
            else
            {
                openingTags[openingTags.length] = tag;  
                openingTagsPos[openingTagsPos.length] = tagStart;  
            }              
        }
    }
    
    return getOpenandOrphanCloseTags(openingTags,openingTagsPos,closingTags,closingTagsPos);
}

function removeLastInstanceOfTag(badtext, str) {
    var charpos = str.lastIndexOf(badtext);
    if (charpos<0) return str;
    let editText = str.substr(charpos);
    let length = editText.indexOf('>');
    let ptone = str.substring(0,charpos);
    let pttwo = str.substring(charpos+length+1);
    return (ptone+pttwo);
}

function removeLastInstance(badtext, str) {
    var charpos = str.lastIndexOf(badtext);
    if (charpos<0) return str;
    let ptone = str.substring(0,charpos);
    let pttwo = str.substring(charpos+(badtext.length));
    return (ptone+pttwo);
}

export function removeTag(htmlarg,realPos,tag)
{
    let html = purifyEntrada(htmlarg);
    let myTagSimplified = tag;
    let pos = myTagSimplified.indexOf(' ');
    if (pos===-1)
        pos = myTagSimplified.indexOf('>');
    myTagSimplified = myTagSimplified.substring(1,pos);
    let closeTag= '</'+myTagSimplified+'>';

    let first = html.substring(0,realPos);
    let second = html.substr(realPos);
    first = removeLastInstance(tag,first);
    second = second.replace(closeTag,'');
    return depurifyEntrada(first) + depurifyEntrada(second);
}

export function removeTagLoose(htmlarg,realPos,looseTag,closeTag)
{
    let html = purifyEntrada(htmlarg);
    let first = html.substring(0,realPos);
    let second = html.substr(realPos);
    first = removeLastInstanceOfTag(looseTag,first);
    second = second.replace(closeTag,'');
    return depurifyEntrada(first) + depurifyEntrada(second);
}

function getCloseTag(tag)
{
    let myTagSimplified = tag;
    let pos = myTagSimplified.indexOf(' ');
    if (pos===-1)
        pos = myTagSimplified.indexOf('>');
    myTagSimplified = myTagSimplified.substring(1,pos);
    let closeTag= '</'+myTagSimplified+'>';
    return closeTag;
}

export function addTagContent(content,tag,closeTag)
{
    //console.log('1:',content,'2:',tag,'3:',closeTag);
    let imgPos=content.indexOf('<img');
    let closingTagPos = content.indexOf('<');
    let checkEndTag = content.indexOf('>');
    if (closingTagPos===-1 || checkEndTag===-1)
        return tag + content + closeTag;

    let sub = content.substr(closingTagPos);
    let closingTagEnd = sub.indexOf('>');
    let leftSide = content.substring(0,closingTagPos);
    let rightSide = content.substr(closingTagPos+closingTagEnd+1);
    if (closingTagPos===imgPos)
    {
        return tag + content.substring(0,closingTagPos+closingTagEnd+1) + closeTag + addTagContent(rightSide,tag,closeTag);
    }
    else
        return tag + leftSide + closeTag + sub.substring(0,closingTagEnd+1) + addTagContent(rightSide,tag,closeTag);
}

function closeSpecificTags(content,tagName='img')
{
    let pos = -1;
    let closePos = -1;
    pos = content.indexOf(('<'+tagName));
    while(pos!==-1)
    {
        closePos = content.indexOf('>',pos+1);
        if (closePos===-1)
            break;
        content = content.slice(0,closePos+1) + '</'+tagName+'>' + content.slice(closePos+1);
        pos = content.indexOf(('<'+tagName), closePos+('</'+tagName+'>').length);
    }
    return content;
}
function closeSingleTags(content)
{
    content = content.replaceAll('<br>','<br></br>');
    return content;
}
function removeInvalidCloseTags(content,tag,closeTag)
{
    content = content.replaceAll('</br>','').replaceAll(tag+closeTag,'');//.replaceAll('</img>','').;
    return content;
}

export function addTag(htmlarg,selectionStart,realPos,tag)
{
    let html = purifyEntrada(htmlarg);
    let closeTag= getCloseTag(tag);
    let first = depurifyEntrada(html.substring(0,selectionStart));
    let content = html.substring(selectionStart,realPos); 
    let second = depurifyEntrada(html.substr(realPos));
    let closedTagsImgBrsContent = closeSingleTags(content);
    return first + depurifyEntrada(removeInvalidCloseTags(addTagContent(closedTagsImgBrsContent,tag,closeTag),tag,closeTag)) + second;
}
//remove any <tag class="whatever"></tag> from text
//####NOT BEING USED
export function removeEmptySpecialTags(text)
{
 return text.replace(/<(\w+)\b(?:\s+[\w\-.:]+(?:\s*=\s*(?:"[^"]*"|"[^"]*"|[\w\-.:]+))?)+\s*\/?><\/\1\s*>/gm, "");
}

let kbyte = 1024;
let mbyte = 1024*kbyte;



  

  

  export var emojis = 'ec-100,ec-1234,ec-grinning,ec-grimacing,ec-grin,ec-joy,ec-rofl,ec-smiley,ec-smile,ec-sweat-smile,ec-laughing,ec-innocent,ec-wink,ec-blush,ec-slightly-smiling-face,ec-upside-down-face,ec-yum,ec-relieved,ec-heart-eyes,ec-kissing-heart,ec-kissing,ec-kissing-smiling-eyes,ec-kissing-closed-eyes,ec-stuck-out-tongue-winking-eye,ec-stuck-out-tongue-closed-eyes,ec-stuck-out-tongue,ec-money-mouth-face,ec-nerd-face,ec-sunglasses,ec-clown-face,ec-cowboy-hat-face,ec-hugs,ec-smirk,ec-no-mouth,ec-neutral-face,ec-expressionless,ec-unamused,ec-roll-eyes,ec-thinking,ec-lying-face,ec-flushed,ec-disappointed,ec-worried,ec-angry,ec-rage,ec-pensive,ec-confused,ec-slightly-frowning-face,ec-frowning-face,ec-persevere,ec-confounded,ec-tired-face,ec-weary,ec-triumph,ec-open-mouth,ec-scream,ec-fearful,ec-cold-sweat,ec-hushed,ec-frowning,ec-anguished,ec-cry,ec-disappointed-relieved,ec-drooling-face,ec-sleepy,ec-sweat,ec-sob,ec-dizzy-face,ec-astonished,ec-zipper-mouth-face,ec-nauseated-face,ec-sneezing-face,ec-mask,ec-face-with-thermometer,ec-face-with-head-bandage,ec-sleeping,ec-zzz,ec-poop,ec-smiling-imp,ec-imp,ec-japanese-ogre,ec-japanese-goblin,ec-skull,ec-ghost,ec-alien,ec-robot,ec-smiley-cat,ec-smile-cat,ec-joy-cat,ec-heart-eyes-cat,ec-smirk-cat,ec-kissing-cat,ec-scream-cat,ec-crying-cat-face,ec-pouting-cat,ec-raised-hands,ec-clap,ec-wave,ec-call-me-hand,ec-plus1,ec--1,ec-facepunch,ec-fist,ec-fist-left,ec-fist-right,ec-v,ec-ok-hand,ec-raised-hand,ec-raised-back-of-hand,ec-open-hands,ec-muscle,ec-pray,ec-handshake,ec-point-up,ec-point-up-2,ec-point-down,ec-point-left,ec-point-right,ec-fu,ec-raised-hand-with-fingers-splayed,ec-metal,ec-crossed-fingers,ec-vulcan-salute,ec-writing-hand,ec-selfie,ec-nail-care,ec-lips,ec-tongue,ec-ear,ec-nose,ec-eye,ec-eyes,ec-bust-in-silhouette,ec-busts-in-silhouette,ec-speaking-head,ec-baby,ec-boy,ec-girl,ec-man,ec-woman,ec-blonde-man,ec-older-man,ec-older-woman,ec-man-with-gua-pi-mao,ec-man-with-turban,ec-policeman,ec-construction-worker-man,ec-guardsman,ec-male-detective,ec-mrs-claus,ec-santa,ec-angel,ec-pregnant-woman,ec-princess,ec-prince,ec-bride-with-veil,ec-man-in-tuxedo,ec-running-man,ec-walking-man,ec-dancer,ec-man-dancing,ec-dancing-women,ec-couple,ec-two-men-holding-hands,ec-two-women-holding-hands,ec-bowing-man,ec-man-facepalming,ec-woman-shrugging,ec-tipping-hand-woman,ec-no-good-woman,ec-ok-woman,ec-raising-hand-woman,ec-pouting-woman,ec-frowning-woman,ec-haircut-woman,ec-massage-woman,ec-couple-with-heart-woman-man,ec-couplekiss-man-woman,ec-family-man-woman-boy,ec-womans-clothes,ec-tshirt,ec-jeans,ec-necktie,ec-dress,ec-bikini,ec-kimono,ec-lipstick,ec-kiss,ec-footprints,ec-high-heel,ec-sandal,ec-boot,ec-mans-shoe,ec-athletic-shoe,ec-womans-hat,ec-tophat,ec-rescue-worker-helmet,ec-mortar-board,ec-crown,ec-school-satchel,ec-pouch,ec-purse,ec-handbag,ec-briefcase,ec-eyeglasses,ec-dark-sunglasses,ec-ring,ec-closed-umbrella,ec-dog,ec-cat,ec-mouse,ec-hamster,ec-rabbit,ec-fox-face,ec-bear,ec-panda-face,ec-koala,ec-tiger,ec-lion,ec-cow,ec-pig,ec-pig-nose,ec-frog,ec-squid,ec-octopus,ec-shrimp,ec-monkey-face,ec-gorilla,ec-see-no-evil,ec-hear-no-evil,ec-speak-no-evil,ec-monkey,ec-chicken,ec-penguin,ec-bird,ec-baby-chick,ec-hatching-chick,ec-hatched-chick,ec-duck,ec-eagle,ec-owl,ec-bat,ec-wolf,ec-boar,ec-horse,ec-unicorn,ec-honeybee,ec-bug,ec-butterfly,ec-snail,ec-beetle,ec-ant,ec-spider,ec-scorpion,ec-crab,ec-snake,ec-lizard,ec-turtle,ec-tropical-fish,ec-fish,ec-blowfish,ec-dolphin,ec-shark,ec-whale,ec-whale2,ec-crocodile,ec-leopard,ec-tiger2,ec-water-buffalo,ec-ox,ec-cow2,ec-deer,ec-dromedary-camel,ec-camel,ec-elephant,ec-rhinoceros,ec-goat,ec-ram,ec-sheep,ec-racehorse,ec-pig2,ec-rat,ec-mouse2,ec-rooster,ec-turkey,ec-dove,ec-dog2,ec-poodle,ec-cat2,ec-rabbit2,ec-chipmunk,ec-paw-prints,ec-dragon,ec-dragon-face,ec-cactus,ec-christmas-tree,ec-evergreen-tree,ec-deciduous-tree,ec-palm-tree,ec-seedling,ec-herb,ec-shamrock,ec-four-leaf-clover,ec-bamboo,ec-tanabata-tree,ec-leaves,ec-fallen-leaf,ec-maple-leaf,ec-ear-of-rice,ec-hibiscus,ec-sunflower,ec-rose,ec-wilted-flower,ec-tulip,ec-blossom,ec-cherry-blossom,ec-bouquet,ec-mushroom,ec-chestnut,ec-jack-o-lantern,ec-shell,ec-spider-web,ec-earth-americas,ec-earth-africa,ec-earth-asia,ec-full-moon,ec-waning-gibbous-moon,ec-last-quarter-moon,ec-waning-crescent-moon,ec-new-moon,ec-waxing-crescent-moon,ec-first-quarter-moon,ec-waxing-gibbous-moon,ec-new-moon-with-face,ec-full-moon-with-face,ec-first-quarter-moon-with-face,ec-last-quarter-moon-with-face,ec-sun-with-face,ec-crescent-moon,ec-star,ec-star2,ec-dizzy,ec-sparkles,ec-comet,ec-sun-behind-small-cloud,ec-partly-sunny,ec-sun-behind-large-cloud,ec-sun-behind-rain-cloud,ec-cloud-with-rain,ec-cloud-with-lightning-and-rain,ec-cloud-with-lightning,ec-zap,ec-fire,ec-boom,ec-cloud-with-snow,ec-snowman,ec-snowman-with-snow,ec-wind-face,ec-dash,ec-tornado,ec-fog,ec-open-umbrella,ec-umbrella,ec-droplet,ec-sweat-drops,ec-ocean,ec-green-apple,ec-apple,ec-pear,ec-tangerine,ec-lemon,ec-banana,ec-watermelon,ec-grapes,ec-strawberry,ec-melon,ec-cherries,ec-peach,ec-pineapple,ec-kiwi-fruit,ec-avocado,ec-tomato,ec-eggplant,ec-cucumber,ec-carrot,ec-hot-pepper,ec-potato,ec-corn,ec-sweet-potato,ec-peanuts,ec-honey-pot,ec-croissant,ec-bread,ec-baguette-bread,ec-cheese,ec-egg,ec-bacon,ec-pancakes,ec-poultry-leg,ec-meat-on-bone,ec-fried-shrimp,ec-fried-egg,ec-hamburger,ec-fries,ec-stuffed-flatbread,ec-hotdog,ec-pizza,ec-spaghetti,ec-taco,ec-burrito,ec-green-salad,ec-shallow-pan-of-food,ec-ramen,ec-stew,ec-fish-cake,ec-sushi,ec-bento,ec-curry,ec-rice-ball,ec-rice,ec-rice-cracker,ec-oden,ec-dango,ec-shaved-ice,ec-ice-cream,ec-icecream,ec-cake,ec-birthday,ec-custard,ec-candy,ec-lollipop,ec-chocolate-bar,ec-popcorn,ec-doughnut,ec-cookie,ec-milk-glass,ec-beer,ec-beers,ec-clinking-glasses,ec-wine-glass,ec-tumbler-glass,ec-cocktail,ec-tropical-drink,ec-champagne,ec-sake,ec-tea,ec-coffee,ec-baby-bottle,ec-spoon,ec-fork-and-knife,ec-plate-with-cutlery,ec-soccer,ec-basketball,ec-football,ec-baseball,ec-tennis,ec-volleyball,ec-rugby-football,ec-8ball,ec-golf,ec-golfing-man,ec-ping-pong,ec-badminton,ec-goal-net,ec-ice-hockey,ec-field-hockey,ec-cricket,ec-ski,ec-skier,ec-snowboarder,ec-person-fencing,ec-ice-skate,ec-bow-and-arrow,ec-fishing-pole-and-fish,ec-boxing-glove,ec-martial-arts-uniform,ec-rowing-man,ec-swimming-man,ec-surfing-man,ec-bath,ec-basketball-man,ec-weight-lifting-man,ec-biking-man,ec-mountain-biking-man,ec-horse-racing,ec-business-suit-levitating,ec-trophy,ec-running-shirt-with-sash,ec-medal-sports,ec-medal-military,ec-1st-place-medal,ec-2nd-place-medal,ec-3rd-place-medal,ec-reminder-ribbon,ec-rosette,ec-ticket,ec-tickets,ec-performing-arts,ec-art,ec-circus-tent,ec-microphone,ec-headphones,ec-musical-score,ec-musical-keyboard,ec-drum,ec-saxophone,ec-trumpet,ec-guitar,ec-violin,ec-clapper,ec-video-game,ec-space-invader,ec-dart,ec-game-die,ec-slot-machine,ec-bowling,ec-red-car,ec-taxi,ec-blue-car,ec-bus,ec-trolleybus,ec-racing-car,ec-police-car,ec-ambulance,ec-fire-engine,ec-minibus,ec-truck,ec-articulated-lorry,ec-tractor,ec-kick-scooter,ec-motorcycle,ec-bike,ec-motor-scooter,ec-rotating-light,ec-oncoming-police-car,ec-oncoming-bus,ec-oncoming-automobile,ec-oncoming-taxi,ec-aerial-tramway,ec-mountain-cableway,ec-suspension-railway,ec-railway-car,ec-train,ec-monorail,ec-bullettrain-side,ec-bullettrain-front,ec-light-rail,ec-mountain-railway,ec-steam-locomotive,ec-train2,ec-metro,ec-tram,ec-station,ec-helicopter,ec-small-airplane,ec-flight-departure,ec-flight-arrival,ec-sailboat,ec-motor-boat,ec-speedboat,ec-ferry,ec-passenger-ship,ec-rocket,ec-artificial-satellite,ec-seat,ec-canoe,ec-anchor,ec-construction,ec-fuelpump,ec-busstop,ec-vertical-traffic-light,ec-traffic-light,ec-checkered-flag,ec-ship,ec-ferris-wheel,ec-roller-coaster,ec-carousel-horse,ec-building-construction,ec-foggy,ec-tokyo-tower,ec-factory,ec-fountain,ec-rice-scene,ec-mountain,ec-mountain-snow,ec-mount-fuji,ec-volcano,ec-japan,ec-camping,ec-tent,ec-national-park,ec-motorway,ec-railway-track,ec-sunrise,ec-sunrise-over-mountains,ec-desert,ec-beach-umbrella,ec-desert-island,ec-city-sunrise,ec-city-sunset,ec-cityscape,ec-night-with-stars,ec-bridge-at-night,ec-milky-way,ec-stars,ec-sparkler,ec-fireworks,ec-rainbow,ec-houses,ec-european-castle,ec-japanese-castle,ec-stadium,ec-statue-of-liberty,ec-house,ec-house-with-garden,ec-derelict-house,ec-office,ec-department-store,ec-post-office,ec-european-post-office,ec-hospital,ec-bank,ec-hotel,ec-convenience-store,ec-school,ec-love-hotel,ec-wedding,ec-classical-building,ec-church,ec-mosque,ec-synagogue,ec-kaaba,ec-shinto-shrine,ec-watch,ec-iphone,ec-calling,ec-computer,ec-keyboard,ec-desktop-computer,ec-printer,ec-computer-mouse,ec-trackball,ec-joystick,ec-clamp,ec-minidisc,ec-floppy-disk,ec-cd,ec-dvd,ec-vhs,ec-camera,ec-camera-flash,ec-video-camera,ec-movie-camera,ec-film-projector,ec-film-strip,ec-telephone-receiver,ec-pager,ec-fax,ec-tv,ec-radio,ec-studio-microphone,ec-level-slider,ec-control-knobs,ec-stopwatch,ec-timer-clock,ec-alarm-clock,ec-mantelpiece-clock,ec-hourglass-flowing-sand,ec-hourglass,ec-satellite,ec-battery,ec-electric-plug,ec-bulb,ec-flashlight,ec-candle,ec-wastebasket,ec-oil-drum,ec-money-with-wings,ec-dollar,ec-yen,ec-euro,ec-pound,ec-moneybag,ec-credit-card,ec-gem,ec-balance-scale,ec-wrench,ec-hammer,ec-hammer-and-pick,ec-hammer-and-wrench,ec-pick,ec-nut-and-bolt,ec-gear,ec-chains,ec-gun,ec-bomb,ec-hocho,ec-dagger,ec-crossed-swords,ec-shield,ec-smoking,ec-skull-and-crossbones,ec-coffin,ec-funeral-urn,ec-amphora,ec-crystal-ball,ec-prayer-beads,ec-barber,ec-alembic,ec-telescope,ec-microscope,ec-hole,ec-pill,ec-syringe,ec-thermometer,ec-label,ec-bookmark,ec-toilet,ec-shower,ec-bathtub,ec-key,ec-old-key,ec-couch-and-lamp,ec-sleeping-bed,ec-bed,ec-door,ec-bellhop-bell,ec-framed-picture,ec-world-map,ec-parasol-on-ground,ec-moyai,ec-shopping,ec-shopping-cart,ec-balloon,ec-flags,ec-ribbon,ec-gift,ec-confetti-ball,ec-tada,ec-dolls,ec-wind-chime,ec-crossed-flags,ec-izakaya-lantern,ec-envelope-with-arrow,ec-incoming-envelope,ec-e-mail,ec-love-letter,ec-postbox,ec-mailbox-closed,ec-mailbox,ec-mailbox-with-mail,ec-mailbox-with-no-mail,ec-package,ec-postal-horn,ec-inbox-tray,ec-outbox-tray,ec-scroll,ec-page-with-curl,ec-bookmark-tabs,ec-bar-chart,ec-chart-with-upwards-trend,ec-chart-with-downwards-trend,ec-page-facing-up,ec-date,ec-calendar,ec-spiral-calendar,ec-card-index,ec-card-file-box,ec-ballot-box,ec-file-cabinet,ec-clipboard,ec-spiral-notepad,ec-file-folder,ec-open-file-folder,ec-card-index-dividers,ec-newspaper-roll,ec-newspaper,ec-notebook,ec-closed-book,ec-green-book,ec-blue-book,ec-orange-book,ec-notebook-with-decorative-cover,ec-ledger,ec-books,ec-open-book,ec-link,ec-paperclip,ec-paperclips,ec-triangular-ruler,ec-straight-ruler,ec-pushpin,ec-round-pushpin,ec-triangular-flag-on-post,ec-white-flag,ec-black-flag,ec-closed-lock-with-key,ec-lock,ec-unlock,ec-lock-with-ink-pen,ec-pen,ec-fountain-pen,ec-memo,ec-crayon,ec-paintbrush,ec-mag,ec-mag-right,ec-yellow-heart,ec-green-heart,ec-blue-heart,ec-purple-heart,ec-black-heart,ec-broken-heart,ec-heavy-heart-exclamation,ec-two-hearts,ec-revolving-hearts,ec-heartbeat,ec-heartpulse,ec-sparkling-heart,ec-cupid,ec-gift-heart,ec-heart-decoration,ec-peace-symbol,ec-latin-cross,ec-star-and-crescent,ec-om,ec-wheel-of-dharma,ec-star-of-david,ec-six-pointed-star,ec-menorah,ec-yin-yang,ec-orthodox-cross,ec-place-of-worship,ec-ophiuchus,ec-aries,ec-taurus,ec-gemini,ec-cancer,ec-leo,ec-virgo,ec-libra,ec-scorpius,ec-sagittarius,ec-capricorn,ec-aquarius,ec-pisces,ec-id,ec-atom-symbol,ec-u7a7a,ec-u5272,ec-radioactive,ec-biohazard,ec-mobile-phone-off,ec-vibration-mode,ec-u6709,ec-u7121,ec-u7533,ec-u55b6,ec-vs,ec-accept,ec-white-flower,ec-ideograph-advantage,ec-u5408,ec-u6e80,ec-u7981,ec-ab,ec-cl,ec-sos,ec-no-entry,ec-name-badge,ec-no-entry-sign,ec-x,ec-o,ec-stop-sign,ec-anger,ec-no-pedestrians,ec-do-not-litter,ec-no-bicycles,ec-non-potable-water,ec-underage,ec-no-mobile-phones,ec-exclamation,ec-grey-exclamation,ec-question,ec-grey-question,ec-low-brightness,ec-high-brightness,ec-trident,ec-fleur-de-lis,ec-children-crossing,ec-beginner,ec-u6307,ec-chart,ec-negative-squared-cross-mark,ec-white-check-mark,ec-diamond-shape-with-a-dot-inside,ec-cyclone,ec-loop,ec-globe-with-meridians,ec-atm,ec-passport-control,ec-customs,ec-baggage-claim,ec-left-luggage,ec-wheelchair,ec-no-smoking,ec-wc,ec-potable-water,ec-mens,ec-womens,ec-baby-symbol,ec-restroom,ec-put-litter-in-its-place,ec-cinema,ec-signal-strength,ec-koko,ec-ng,ec-ok,ec-up,ec-cool,ec-new,ec-free,ec-keycap-ten,ec-pause-button,ec-next-track-button,ec-stop-button,ec-record-button,ec-play-or-pause-button,ec-previous-track-button,ec-fast-forward,ec-rewind,ec-twisted-rightwards-arrows,ec-repeat,ec-repeat-one,ec-arrow-up-small,ec-arrow-down-small,ec-arrow-double-up,ec-arrow-double-down,ec-arrows-counterclockwise,ec-abc,ec-abcd,ec-capital-abcd,ec-symbols,ec-musical-note,ec-notes,ec-curly-loop,ec-arrows-clockwise,ec-heavy-plus-sign,ec-heavy-minus-sign,ec-heavy-division-sign,ec-heavy-dollar-sign,ec-currency-exchange,ec-end,ec-back,ec-on,ec-top,ec-soon,ec-radio-button,ec-white-circle,ec-black-circle,ec-red-circle,ec-large-blue-circle,ec-small-orange-diamond,ec-small-blue-diamond,ec-large-orange-diamond,ec-large-blue-diamond,ec-small-red-triangle,ec-black-large-square,ec-white-large-square,ec-small-red-triangle-down,ec-black-medium-small-square,ec-white-medium-small-square,ec-black-square-button,ec-white-square-button,ec-speaker,ec-sound,ec-loud-sound,ec-mute,ec-mega,ec-loudspeaker,ec-bell,ec-no-bell,ec-black-joker,ec-mahjong,ec-flower-playing-cards,ec-thought-balloon,ec-right-anger-bubble,ec-speech-balloon,ec-left-speech-bubble,ec-clock1,ec-clock2,ec-clock3,ec-clock4,ec-clock5,ec-clock6,ec-clock7,ec-clock8,ec-clock9,ec-clock10,ec-clock11,ec-clock12,ec-clock130,ec-clock230,ec-clock330,ec-clock430,ec-clock530,ec-clock630,ec-clock730,ec-clock830,ec-clock930,ec-clock1030,ec-clock1130,ec-clock1230'.split(',');